<template>
  <lv-button :type="modelValue.$invalid ? 'button' : 'submit'" :disabled="modelValue.$invalid">
    <slot />
  </lv-button>
</template>

<script>
  import { LvButton } from '~~/common/components/loginet-vue-shop/index.mjs';

  export default {
    name: 'AwFormButtonVersion2',
    components: {
      LvButton,
    },
    props: {
      modelValue: {
        type: Object,
        required: true,
      },
    },
  };
</script>
